import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { CurrentUserService } from '../../core/auth/current-user.service';

/**
 * "User" navigation tab (Admin-only). Rendered immediately after RIPT Summaries; hidden entirely
 * for non-admin roles.
 */
@Component({
  selector: 'app-user-menu',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  template: `
    @if (current.isAdmin()) {
      <a
        routerLink="/users"
        routerLinkActive="slds-is-active"
        class="slds-context-bar__label-action"
        role="menuitem"
      >
        User
      </a>
    }
  `,
  styles: [
    `
      :host {
        display: flex;
        align-items: stretch;
      }
    `,
  ],
})
export class UserMenuComponent {
  readonly current = inject(CurrentUserService);
}
